var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "thumbUpIconTitle"
  }, "Thumb Up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "thumbUpIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "thumbUpIconDesc"
  }, "Icon of a a hand with a thumb pointing up")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,8.73984815 C8,8.26242561 8.17078432,7.80075162 8.4814868,7.43826541 L13.2723931,1.84887469 C13.7000127,1.34998522 14.4122932,1.20614658 15,1.5 C15.5737957,1.78689785 15.849314,2.45205792 15.6464466,3.06066017 L14,8 L18.6035746,8 C18.7235578,8 18.8432976,8.01079693 18.9613454,8.03226018 C20.0480981,8.22985158 20.7689058,9.27101818 20.5713144,10.3577709 L19.2985871,17.3577709 C19.1256814,18.3087523 18.2974196,19 17.3308473,19 L10,19 C8.8954305,19 8,18.1045695 8,17 L8,8.73984815 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18 L4,9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.6ca40c960d081c0b8534f782f7e2cf59.svg";
export { ForwardRef as ReactComponent };